<template>
  <div id="app">
    <router-view></router-view>
    <div class="tip" v-text="tip" v-if="tip"></div>
  </div>
</template>

<script>
// import cache from './assets/lib/cache'
import { mapState } from 'vuex'

export default {
  name: 'app',
  computed: {
    ...mapState(['tip'])
  },
  mounted () {
    // 此处需要获取区域的信息，规则如下 1、登录成功进入首页 2、随机访问任意页面
    // const user = cache.getSession('dtit_user')
    // if (user && this.$route.name) {
    //
    // }
  }
}
</script>

<style lang="less">
@import "./assets/less/base.less";

.tip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  background-color: rgb(0, 0, 0, .5);
  border-radius: 10px;
  padding: 15px;
  animation: fadeInOut 3s 1 forwards;
}

@-webkit-keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  35% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.addgroup {
    margin-right: 20px !important;
  }
</style>
